import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {
    getFactoriesByGroupID,
    getAllRoutesByFactoryID,
    getFactoryEmployeeAttendanceReportData
     
};

async function getFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/OperationEntity/GetFactoriesByGroupID','groupID=' + groupID);
    let array = []
    for (let item of Object.entries(response.data)) {
        if (item[1]) {
        array[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return array;
}


async function getAllRoutesByFactoryID(factoryID) {
    var routeArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllRoutesByFactoryID', 'factoryID=' + factoryID);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            routeArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return routeArray;  
}

async function getFactoryEmployeeAttendanceReportData(data) {
    var model = {
        groupID: parseInt(data.groupID),
        operationEntityID: parseInt(data.factoryID),
        collectionPointID: parseInt(data.routeID),
        factoryEmployeeNumber: (data.employeeNumber === "0" || data.employeeNumber.length === 0) ? null : data.employeeNumber,
        toDate: data.toDate,
        fromDate: data.fromDate        
    };
    const response = await CommonPost('/api/FactoryEmployeeAttendanceReport/getFactoryEmployeeAttendanceReportData', null, model);
    return response.data;
    
}



